import React, { ButtonHTMLAttributes, FC } from 'react'
import styled from 'styled-components'

import { useTranslation } from 'helpers/hooks/useTranslation'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { primaryColor } from 'uiComponents/constants/colors'

const Button = styled.button<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: ${primaryColor};
  padding: 1px 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  disabled?: boolean
  label?: string
}

const ResetButton: FC<Props> = props => {
  const { disabled, label, onClick } = props
  const { t } = useTranslation()

  return (
    <Button
      disabled={disabled}
      onClick={() => (disabled ? () => {} : onClick)}
      {...props}
    >
      <Icon size={IconSize.S} asset={IconName.IcReset} />
      {label ?? t('Zurücksetzen')}
    </Button>
  )
}

export default ResetButton
